import { Box, FormGroup, InputAdornment, TextField } from '@mui/material';
import { useField } from 'formik';
import { CURRENCY } from '../../../config/appConfig';
import { TextWrapper } from './useTextWrapper';
import { useTranslation } from 'react-i18next';
import { CustomTooltip } from '../common/tooltip';

export const InputWrapper = ({
	placeholder = '',
	isTextArea = false,
	rows = 1,
	type = 'text',
	disabled = false,
	labelClass = '',
	errorClass = '',
	inputClass = '',
	showCurrency = false,
	externalErrorMessage = '',
	hideErrorMessage = false,
	isCurrencyText = false,
	dataTestID = '',
	errorStateTestID = '',
	readOnly = false,
	autoFocus = false,
	endIcon = null,
	maxLength = null,
	tooltipText = null,
	onFocus = () => { },
	onBlur = () => { },
	endIconClick = () => { },
	onChanges = null,
	...props
}) => {
	const { t } = useTranslation();
	const [field, meta, helpers] = useField(props);
	return (
		<FormGroup className="w-full h-auto">
			<Box className="flex flex-col items-start w-full">
				<Box className="flex flex-0 items-center !relative w-full">
					<TextWrapper
						classList="truncate-word"
						type="caption"
						text={
							<span>
								<span>
									{typeof props?.label === 'string'
										? t(props?.label)
										: props?.label}
								</span>
								{(meta.error || externalErrorMessage) && props?.label ? (
									<span className="!text-red-500 !text-[16px] !absolute !top-[-3px]">
										*
									</span>
								) : null}
							</span>
						}></TextWrapper>
					{tooltipText && (
						<CustomTooltip
							id={props?.label}
							text={tooltipText}></CustomTooltip>
					)}
				</Box>
				<TextField
					autoFocus={autoFocus}
					sx={{
						'& input[type=number]': {
							MozAppearance: 'textfield',   // Firefox
						},
						'& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
							WebkitAppearance: 'none',    // Chrome, Safari, Edge, Opera
							margin: 0,
						},
					}}
					autoComplete="on"
					{...field}
					error={
						(meta.error || externalErrorMessage) && meta.touched ? true : false
					}
					helperText={
						<span>
							{meta.touched & !hideErrorMessage
								? t(meta.error || externalErrorMessage)
								: ''}
						</span>
					}
					placeholder={placeholder}
					FormHelperTextProps={{
						className: `${errorClass}`,
						'data-testid':
							(meta.error || externalErrorMessage) && meta.touched
								? errorStateTestID
								: '',
					}}
					multiline={isTextArea}
					maxRows={isTextArea ? 6 : 1}
					InputLabelProps={{ shrink: false, style: { display: 'none' } }}
					variant={'outlined'}
					disabled={disabled}
					size="small"
					onFocus={() => {
						onFocus && onFocus();
					}}
					onBlur={(e) => {
						onBlur && onBlur(e);
					}}
					onClick={(e) => {
						e.stopPropagation();
					}}
					onChange={(e) => {
						const inputValue = e.target.value;
						if (isCurrencyText) {
							const numericValue = inputValue.replace(/[^0-9.]/g, '');
							const value = numericValue.replace(/,/g, '');
							helpers.setValue(value);
							onChanges && onChanges(value);
						} else {
							helpers.setValue(inputValue);
						}

					}}
					inputProps={{
						maxLength: maxLength,
						'aria-label': field.name,
						'data-testid': dataTestID,
						className: inputClass ? inputClass : ''
					}}
					InputProps={{
						readOnly: readOnly,
						startAdornment: showCurrency ? (
							<>
								<InputAdornment className='currency-symbol' position="start">{CURRENCY}</InputAdornment>
							</>
						) : null,
						endAdornment: endIcon ? endIcon : null,
						'aria-label': field.name,
						className: inputClass ? inputClass : ''
					}}
					minRows={rows}
					fullWidth={true}
					className={`mt-1 reusable-input ${isTextArea ? 'input-text-area' : ''
						} ${props.classList ? props.classList : props.classlist || ''}`}
					type={type ? type : showCurrency ? 'number' : 'text'}
					name={field?.name}
					value={isCurrencyText && field.value
						? field.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') // Format with commas
						: field.value || ''}
					{...props}
				/>
			</Box>
		</FormGroup>
	);
};
